import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { inject } from '@app/providers/QAU.ContextProvider';
import LocalizedText from '@LocalizedText';
import { isMobileMode, isEditingArtworkWarningsEnabled } from '@app/utils/utils';
import { closeFinishedArtworkInfo } from '@app/actions/popupsActions';

import DefaultButton from '@components/buttons/default-btn/DefaultButton';
import Popup from '../Popup';
import './ArtworkInfoPopup.scss';

const copyText = ({ target }) => {
  const {
    dataset: { copyValue },
  } = target;

  navigator.clipboard.writeText(copyValue);
};

const ArtworkInfo = ({ closeFinishedArtworkInfo,
                       warningsEnabled,
                       artworkInfo: { active, artwork_id, sku, skuChanged, impositionCountChanged, artwork_status, relatedArtworkId, editFlow },
                       mobileView
}) =>
  active && (
    <Popup
      className={classnames('artwork-info-popup', { mobile: mobileView })}
      closeLocKey="qau-ok-btn"
      titleLocKey="qau-application-title"
      closePopup={closeFinishedArtworkInfo}
    >
      <div className="info-section">
        <span className="section-title">
          <LocalizedText id="qau-artwork-id-title" />
        </span>
        <span className="artwork-id">{editFlow ? relatedArtworkId : artwork_id}</span>
        <DefaultButton className="copy-button" locKey="qau-copy-btn" data-copy-value={editFlow ? relatedArtworkId : artwork_id} onClick={copyText} tabIndex="-1" />
      </div>
      <div className="info-section">
        <span className="section-title">
          <LocalizedText id="qau-sku-title" />
        </span>
        <span className="artwork-sku">{sku}</span>
        <DefaultButton className="copy-button" locKey="qau-copy-btn" data-copy-value={sku} onClick={copyText} tabIndex="-1" />
      </div>
      <div className="info-section">
        <span className="section-title">
          <LocalizedText id="qau-artwork-status-title" />
        </span>
        <span className="artwork-status">{artwork_status}</span>
      </div>
      { warningsEnabled && (
        <div className="warning-section">
          <span className="section-title">
            <LocalizedText id="qau-artwork-warnings-title" />
          </span>
          {!!skuChanged && (
            <span className="warning-text">
               <LocalizedText id="qau-artwork-sku-changed-warning" />
            </span>
          )}
          {!!impositionCountChanged && (
            <span className="warning-text">
               <LocalizedText id="qau-artwork-imposition-count-changed-warning" />
            </span>
          )}
        </div>
      )}
    </Popup>
  );

ArtworkInfo.propTypes = {
  artworkInfo: PropTypes.object.isRequired,
  closeFinishedArtworkInfo: PropTypes.func.isRequired,
  warningsEnabled: PropTypes.bool.isRequired,
  mobileView: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
  popups: { artworkInfo },
  matrix: { ctx }
}, { flowConfig }) => ({
  artworkInfo,
  mobileView: isMobileMode(ctx),
  warningsEnabled: isEditingArtworkWarningsEnabled(flowConfig)
});

export default inject('flowConfig')(connect(mapStateToProps, { closeFinishedArtworkInfo })(ArtworkInfo));
